export default function ExperienceTimeline({ items }) {
  return (
    <div className="timeline" aria-label="职业经历">
      {items.map((item) => (
        <article className="timeline__item" key={`${item.period}-${item.studio}`}>
          <time>{item.period}</time>
          <div>
            <h3>{item.studio}</h3>
            <strong>{item.role}</strong>
          </div>
          <p>{item.description}</p>
        </article>
      ))}
    </div>
  );
}
